import FileTextEdit from './FileTextEdit';

export default {
    Edit: FileTextEdit
};
